/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Note_AllInputs */

const en_note_all = /** @type {(inputs: Note_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Notes`)
};

const ar_note_all = /** @type {(inputs: Note_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل الملاحظات`)
};

const bn_note_all = /** @type {(inputs: Note_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সব নোট`)
};

const de_note_all = /** @type {(inputs: Note_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Notizen`)
};

const es_note_all = /** @type {(inputs: Note_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las notas`)
};

const fr_note_all = /** @type {(inputs: Note_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les notes`)
};

const pt_note_all = /** @type {(inputs: Note_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as notas`)
};

const zh_note_all = /** @type {(inputs: Note_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有注释`)
};

const tr_note_all = /** @type {(inputs: Note_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm Notlar`)
};

const ru_note_all = /** @type {(inputs: Note_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все заметки`)
};

const pl_note_all = /** @type {(inputs: Note_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie notatki`)
};

/**
* | output |
* | --- |
* | "All Notes" |
*
* @param {Note_AllInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const note_all = /** @type {((inputs?: Note_AllInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Note_AllInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_note_all(inputs)
	if (locale === "bn") return bn_note_all(inputs)
	if (locale === "de") return de_note_all(inputs)
	if (locale === "es") return es_note_all(inputs)
	if (locale === "fr") return fr_note_all(inputs)
	if (locale === "pt") return pt_note_all(inputs)
	if (locale === "zh") return zh_note_all(inputs)
	if (locale === "tr") return tr_note_all(inputs)
	if (locale === "ru") return ru_note_all(inputs)
	if (locale === "pl") return pl_note_all(inputs)
	return en_note_all(inputs)
});